import { z } from 'src/lib'
import { OperacionCorporateCuentaFields, OperacionCorporateFields } from './fields'

export const schemaOperacionCorporateUpdate = z.object({
    [OperacionCorporateFields.CodSectorComercial]: z.number(),
    [OperacionCorporateFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionCorporateFields.FechaVencimiento]: z.date()
})

export type OperacionCorporateUpdate = z.infer<typeof schemaOperacionCorporateUpdate>

export const schemaOperacionCorporateInsert = z.object({
    [OperacionCorporateFields.CodPais]: z.number(),
    [OperacionCorporateFields.CodSectorComercial]: z.number(),
    [OperacionCorporateFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionCorporateFields.FechaVencimiento]: z.date(),
    [OperacionCorporateFields.BitEnvio]: z.boolean(),
    [OperacionCorporateFields.Cuentas]: z.array(
        z.object({
            [OperacionCorporateCuentaFields.NroCuenta]: z.string(),
            [OperacionCorporateCuentaFields.RazonSocial]: z.string(),
            [OperacionCorporateCuentaFields.CodMoneda]: z.number(),
            [OperacionCorporateCuentaFields.ImporteConcertacion]: z.number(),
            [OperacionCorporateCuentaFields.ImporteDPV]: z.number(),
            [OperacionCorporateCuentaFields.ImporteFOP]: z.number()
        })
    )
})

export type OperacionCorporateInsert = z.infer<typeof schemaOperacionCorporateInsert>

export const schemaOperacionCorporateCuentaInsert = z.object({
    [OperacionCorporateCuentaFields.NroCuenta]: z.string(),
    [OperacionCorporateCuentaFields.RazonSocial]: z.string(),
    [OperacionCorporateCuentaFields.CodMoneda]: z.number(),
    [OperacionCorporateCuentaFields.ImporteConcertacion]: z.number(),
    [OperacionCorporateCuentaFields.ImporteDPV]: z.number(),
    [OperacionCorporateCuentaFields.ImporteFOP]: z.number()
})

export type OperacionCorporateCuentaInsert = z.infer<typeof schemaOperacionCorporateCuentaInsert>

export const schemaOperacionCorporateCuentaUpdate = z.object({
    [OperacionCorporateCuentaFields.NroCuenta]: z.string(),
    [OperacionCorporateCuentaFields.RazonSocial]: z.string(),
    [OperacionCorporateCuentaFields.CodMoneda]: z.number().optional()
})

export type OperacionCorporateCuentaUpdate = z.infer<typeof schemaOperacionCorporateCuentaUpdate>

export const schemaOperacionCorporateCuentaDetalleUpdate = z.object({
    [OperacionCorporateCuentaFields.ImporteConcertacion]: z.number().optional(),
    [OperacionCorporateCuentaFields.ImporteDPV]: z.number().optional(),
    [OperacionCorporateCuentaFields.ImporteFOP]: z.number().optional()
})

export type OperacionCorporateCuentaDetalleUpdate = z.infer<typeof schemaOperacionCorporateCuentaDetalleUpdate>